import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import FeatureSection from "../components/feature-section";


function About() {
  return (
    <div className="w-full min-h-[100vh] flex flex-col items-center justify-between bg-white dark:bg-gray-900">
    <Navbar />
    <FeatureSection />
    <Footer />
  </div>
  );
}

export default About;
